export const enum USER_WORK_AREA {
  ADMINISTRATION = 'administration',
  SOFTWARE = 'software',
  HARDWARE = 'hardware',
  CUSTOMER_SERVICE = 'customerservice',
  LOGISTICS = 'logistics',
  REPAIRS = 'repairs',
  MARKETING = 'marketing',
  COMMERCIAL = 'commercial',
}
export const UserWorkAreaString = {
  administration: 'Administración',
  software: 'Software',
  hardware: 'Hardware',
  customerservice: 'Servicio al cliente',
  logistics: 'Logística',
  // repairs: 'Reparaciones',
  // marketing: 'Marketing',
  // commercial: 'Comercial',
};
